import { APITypesV1 } from "@cur8/api-client";

// What an operator calls the ECG depends on the device in the room, not on the
// exam. Gen 1 rooms run CardioSecur and call it CardioSecur ECG; Gen 2 rooms
// run Norav and call it ECG (12-lead), the US included. Both confirmed with
// Yuan on AB#102209, so Norav is a decision rather than a fallback and the
// generic label is only reached by a device nobody has named yet.
export const GENERIC_ECG_LABEL = "ECG (12-lead)";

const DEVICE_LABELS: Record<APITypesV1.EcgType, string> = {
  [APITypesV1.EcgType.EcgCardiosecur]: "CardioSecur ECG",
  [APITypesV1.EcgType.EcgNorav]: GENERIC_ECG_LABEL,
};

/**
 * Read from the assigned device rather than the scan id: an ECG that has not
 * run yet has no scan entry, which is exactly when a screen has to name it.
 */
export function ecgScanLabel(
  deviceType: APITypesV1.EcgType | undefined
): string {
  return (deviceType && DEVICE_LABELS[deviceType]) ?? GENERIC_ECG_LABEL;
}
